import { render, staticRenderFns } from "./StudipFolderSize.vue?vue&type=template&id=745f2510&"
import script from "./StudipFolderSize.vue?vue&type=script&lang=js&"
export * from "./StudipFolderSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports